<div
    class="c-sidebar c-sidebar-dark c-sidebar-fixed"
    [ngClass]="{ 'c-sidebar-show': sidebarShowMobile, 'c-sidebar-lg-show': sidebarShowLG }"
    id="sidebar"
>
    <div class="c-sidebar-brand">
        <img class="c-sidebar-brand-full" src="assets/img/brand/logo.png" height="46" alt="Slovgen Logo" />
    </div>
    <ui-inline-profile></ui-inline-profile>
    <ui-menu [menuItems]="menuItems"></ui-menu>
    <div class="version">{{ 'common.version' | translate }}: {{ version }}</div>
</div>
